import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useFragment } from 'react-relay';
import { graphql } from 'babel-plugin-relay/macro';

import usePageTitle from '../../hooks/usePageTitle';

import type { FaqQuery$key } from './__generated__/FaqQuery.graphql';

import '../../StickyLayout.sass';
import './Faq.sass';

import Accordion from '../../uikit/Accordion';

import { ReactComponent as DudeRed } from '../../assets/img/dude/dude-red.svg';
import { ReactComponent as DudeBlue } from '../../assets/img/dude/dude-blue.svg';
import { FaqQuery } from './__generated__/FaqQuery.graphql';

interface Props {
	query: FaqQuery$key;
}

type Children = NonNullable<
	NonNullable<NonNullable<FaqQuery['_children']>['items']>[0]
>;

function Faq(props: Props) {
	const data = useFragment(
		graphql`
			fragment FaqQuery on HomePublishedContent {
				_children {
					items {
						... on FAQPagePublishedContent {
							_name
							metaTitle
							title
							content
							contentPicture {
								_name
								_url
							}
							_children {
								items {
									... on FaqItemPublishedContent {
										question
										answer
										scrollID
										_url
									}
								}
							}
						}
					}
				}
			}
		`,
		props.query
	);

	const [fetchedData, setFetchedData] = useState<Children>();

	useEffect(() => {
		data._children?.items?.forEach((item) => {
			if (item && Object.keys(item).length !== 0) {
				setFetchedData(item);
			}
		});
	}, [data]);

	const [faqAccordionContent, setFaqAccordionContent] = useState<
		{
			title: string;
			body: string;
			scrollID: string;
		}[]
	>();

	useEffect(() => {
		const tempArray: { title: string; body: string; scrollID: string }[] = [];

		if (
			fetchedData &&
			fetchedData?._children &&
			fetchedData._children.items &&
			fetchedData._children.items?.length > 0
		) {
			const { items } = fetchedData._children;
			items.forEach((item, index: number) => {
				if (item) {
					const { _url: url, question, answer } = item;
					if (url && question && answer) {
						const scrollID = url.replace(/\/(faq)?/g, '');

						tempArray[index] = {
							title: question,
							body: answer,
							scrollID,
						};
					}
				}
			});
		}
		setFaqAccordionContent(tempArray);
	}, [fetchedData]);

	usePageTitle(fetchedData?.metaTitle || undefined);

	return (
		<div className="faq-page">
			<Container>
				<Row className="sticky-layout">
					<Col xs={12} lg={5} className="sticky-layout__sidebar">
						<Row className="sticky-layout__sidebar-content">
							{fetchedData && (
								<Col xs={12} md={6} lg={12} className="sticky-layout__heading">
									<h1 className="uikit-heading-hg">{fetchedData.title}</h1>
								</Col>
							)}
							<Col xs={12} md={6} lg={12} className="sticky-layout__animation">
								<DudeRed />
								<DudeBlue />
							</Col>
						</Row>
					</Col>
					{faqAccordionContent && (
						<Col
							xs={12}
							lg={{ offset: 1, span: 6 }}
							className="sticky-layout__content"
						>
							<Accordion
								isTinyTitle
								withGaps={false}
								content={faqAccordionContent}
							/>
						</Col>
					)}
				</Row>
			</Container>
		</div>
	);
}

export default Faq;
